<template>
  <div>
    <v-container grid-list-xl class="pa-5">
      <m-breadcrum :items="bread"></m-breadcrum>
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4" sm="12">
              <v-timeline dense clipped align-top>
                <v-timeline-item icon="mdi-check" fill-dot>
                  <div class="black--text pt-1">Ajuan Cuti</div>
                  <div class="grey--text caption">{{ getDeepObj(detail, 'wkt_ajuan') | toDT }}</div>
                </v-timeline-item>
                <v-timeline-item
                  v-for="(tingkat, t) in tingkats"
                  :key="t"
                  :color="Number(tingkat.k_status) === 5 ? 'primary' : 'grey'"
                  :icon="Number(tingkat.k_status) === 5 ? 'mdi-check' : ''"
                  fill-dot
                >
                  <div class="black--text pt-1">Pesetujuan {{ getDeepObj(tingkat, 'groups.nama') }}</div>
                  <div class="grey--text caption"></div>
                </v-timeline-item>
                <v-timeline-item
                  :color="Number(getDeepObj(detail, 'k_status')) === 5 ? 'primary' : 'grey'"
                  :icon="Number(getDeepObj(detail, 'k_status')) === 5 ? 'mdi-check' : ''"
                  fill-dot
                >
                  <div class="black--text pt-1">Hasil Ajuan</div>
                  <div class="grey--text caption"></div>
                </v-timeline-item>
              </v-timeline>
            </v-col>
            <v-col cols="12" md="8" sm="12" class="mt-5">
              <div class="d-flex justify-space-between">
                <div class="text-h6">{{ getDeepObj(detail, 'cuti_kategori.nama') }}</div>
                <div v-if="jenis !== 'cuti.setuju'">
                  <v-btn v-if="Number(getDeepObj(detail, 'k_status')) < 4" depressed small @click="onEdit"
                    ><v-icon>mdi-pencil</v-icon></v-btn
                  >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="[4].includes(Number(detail.k_status))"
                        depressed
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="batalAjuan"
                        ><v-icon color="red">mdi-cancel</v-icon></v-btn
                      >
                    </template>
                    <span>
                      <span>Batalkan Ajuan</span>
                    </span>
                  </v-tooltip>
                </div>
              </div>
              <div class="caption grey--text">Diajukan pada {{ getDeepObj(detail, 'wkt_ajuan') | toDT }}</div>
              <v-alert
                v-if="Number(getDeepObj(detail, 'k_status')) === 8"
                class="mt-2"
                text
                dense
                color="red"
                icon="mdi-clock-outline"
                >
                Ajuan Dibatalkan

                <div class="text-caption text-grey">
                  Oleh: {{ getDeepObj(detail, 'users.nama') }},
                  {{ getDeepObj(detail, 'updated_at') | toDT }}
                </div>
              </v-alert>
              <v-alert
                v-else-if="Number(getDeepObj(detail, 'k_status')) !== 5"
                class="mt-2"
                text
                dense
                color="warning"
                icon="mdi-clock-outline"
                >Menunggu persetujuan dari atasan</v-alert
              >

              <v-row dense>
                <v-col cols="12" md="4" sm="12">
                  <v-list-item>
                    <v-list-item-avatar>
                      <v-icon class="primary" dark> mdi-account </v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <div class="body-1 font-weight-medium">{{ getDeepObj(detail, 'users.nama') }}</div>
                      <div class="caption grey--text">{{ getDeepObj(detail, 'users.email') || '' }}</div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <div class="text-h6 black--text mt-4 text-right">{{
                    duration(getDeepObj(detail, 'tgl_awal'), getDeepObj(detail, 'tgl_akhir'))
                  }}</div>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <div class="text-h5 primary--text mt-4 text-right">{{
                    countDate(getDeepObj(detail, 'tgl_awal'), getDeepObj(detail, 'tgl_akhir'))
                  }}</div>
                  <div class="primary--text text-right font-weight-bold">Hari Kerja</div>
                </v-col>
              </v-row>
              <div class="text-h6"> Keterangan: </div>
              <div>
                {{ getDeepObj(detail, 'keterangan') }}
              </div>
              <div class="mt-3 text-h6"> File Lampiran </div>
              <div>
                <template v-if="getDeepObj(detail, 'lampiran')">
                  <v-btn color="primary" small @click="onLampiran">Unduh Lampiran <v-icon right>mdi-download</v-icon></v-btn>
                </template>
                <template v-else>
                  <span class="warning--text">Berkas tidak tersedia</span>
                </template>
              </div>
              <div v-if="(getDeepObj(detail, 'petugas_setujus') || []).length > 0" class="mt-3 text-h6">
                Daftar Persetujuan
              </div>

              <v-list>
                <v-list-item v-for="(petugas, p) in getDeepObj(detail, 'petugas_setujus') || []" :key="p">
                  <v-list-item-avatar>
                    <v-icon class="primary" dark> mdi-account </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <div class="d-flex justify-space-between">
                      <div class="font-weight-bold mr-5">
                        {{ getDeepObj(petugas, 'users.nama') }}<br />
                        <span class="font-weight-regular caption grey--text">
                          {{ getDeepObj(petugas, 'groups.nama') }}
                        </span>
                        <div class="mt-2 font-weight-medium">
                          {{ getDeepObj(petugas, 'alasan') || '' }}
                        </div>
                      </div>
                      <div class="text-right">
                        <template v-if="jenis === 'cuti.setuju'">
                          <template
                            v-if="
                              Number(getDeepObj(current_user, 'user_id')) === Number(getDeepObj(petugas, 'user_id')) &&
                              Number(getDeepObj(petugas, 'k_status')) === 4
                            "
                          >
                            <v-btn small depressed color="success" @click="setujui"
                            ><v-icon left>mdi-check</v-icon>Setujui</v-btn
                            >
                            <v-btn class="mx-2" small depressed outlined color="red" @click="tolak"
                            ><v-icon left>mdi-close</v-icon>Tolak</v-btn
                            >
                          </template>
                          <template v-else>
                            <div class="text-right">
                              <i v-if="Number(petugas.k_status) === 4" class="body-1 warning--text">Menunggu</i><br />
                              <i v-if="Number(petugas.k_status) === 5" class="body-1 success--text">Disetujui</i><br />
                              <i v-if="Number(petugas.k_status) === 6" class="body-1 red--text">Ditolak</i><br />
                            </div>
                            <span v-if="petugas.wkt_proses" class="font-weight-regular caption grey--text">
                              {{ getDeepObj(petugas, 'wkt_proses') | toDT }}
                            </span>
                          </template>
                        </template>
                        <template v-else>
                          <i v-if="Number(petugas.k_status) === 6" class="body-1 red--text">Ditolak</i>
                          <i v-if="Number(petugas.k_status) === 4" class="body-1 warning--text">Menunggu</i>
                          <i v-if="Number(petugas.k_status) === 5" class="body-1 success--text">Disetujui</i>
                          <div v-if="petugas.wkt_proses" class="font-weight-regular caption grey--text">
                            {{ getDeepObj(petugas, 'wkt_proses') | toDT }}
                          </div>
                        </template>
                      </div>
                    </div>
                  </v-list-item-content>

                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
    <FormAjuan ref="form" @reload="fetchData" :kategoris="kategoriCuti" />
  </div>
</template>
<script>
import FormAjuan from '@/modules/cuti/components/FormAjuan.vue'
import { countDate, duration } from '../../../tools'

export default {
  data() {
    return {
      detail: {},
      kategoriCuti: [],
    }
  },
  components: {
    FormAjuan,
  },
  computed: {
    orgsId() {
      return this.getDeepObj(this.$route, 'params.organisasi_id')
    },

    cutiId() {
      return this.getDeepObj(this.$route, 'params.cuti_id')
    },

    jenis() {
      return this.getDeepObj(this.$route, 'name')
    },

    bread() {
      return [
        {
          icon: 'mdi-home',
          title: 'Riwayat Cuti',
          to: {
            name: 'riwayatCuti',
            params: { organisasi_id: this.orgsId },
          },
        },
        {
          title: 'Detail Cuti',
        },
      ]
    },

    tingkats() {
      let petugases = this.getDeepObj(this.detail, 'petugas_setujus') || []
      return petugases.filter((v, i, a) => a.findIndex((v2) => v2.tingkat === v.tingkat) === i)
    },
  },

  activated() {
    this.loadKategori()
    this.fetchData()
  },

  methods: {
    countDate,
    duration,
    loadKategori() {
      this.$store
        .dispatch('cuti/cekSaldo', {
          organisasi_id: this.organisasi_id,
        })
        .then(({ data }) => {
          this.kategoriCuti = data || []
        })
        .catch((e) => e)
    },
    fetchData() {
      if (!this.cutiId) return
      this.$store
        .dispatch('cuti/detail', {
          organisasi_id: this.organisasi_id,
          cuti_id: `${this.cutiId}/detail`,
        })
        .then(({ data }) => {
          this.detail = data
        })
    },
    onEdit() {
      this.$store
        .dispatch('cuti/detail', { organisasi_id: this.organisasi_id, cuti_id: `${this.cutiId}/detail` })
        .then((resp) => {
          this.$refs.form.open(resp.data || {})
        })
    },
    setujui() {
      this.$confirmDanger(`Apakah Anda yakin akan menyetujui data ini ?`, {
        keterangan: 'keterangan',
      })
        .then((form) =>
          this.$store.dispatch('cuti/actions', {
            organisasi_id: this.organisasi_id,
            obj: {
              url: `${this.getDeepObj(this.detail, 'cuti_id')}/update-status`,
              params: {
                k_status: 5,
                keterangan: form.keterangan,
              },
            },
          })
        )
        .then(() => {
          this.$info('Data berhasil disetujui')
        })
        .then(() => this.fetchData())
        .catch((e) => e)
    },
    tolak() {
      this.$confirmDanger(
        `Apakah Anda yakin akan menolak data ini ?
      `,
        {
          keterangan: 'keterangan',
        }
      )
        .then((form) => {
          this.$store.dispatch('cuti/actions', {
            organisasi_id: this.organisasi_id,
            obj: {
              url: `${this.getDeepObj(this.detail, 'cuti_id')}/update-status`,
              params: {
                k_status: 6,
                keterangan: form.keterangan,
              },
            },
          })
        })
        .then(() => {
          this.$info('Data berhasil ditolak')
        })
        .then(() => this.load())
        .catch((e) => e)
    },
    batalAjuan() {
      this.$confirmDanger(
        `Apakah Anda yakin akan membatalkan data ajuan ini ?<br>
        <div class="mt-2 grow">
          Tipe Cuti ${this.getDeepObj(this.detail, 'keterangan')} pada Tanggal ${this.duration(
          this.detail.tgl_awal,
          this.detail.tgl_akhir
        )}<br>
        </div>
      `
      )
        .then(() =>
          this.$store.dispatch('cuti/actions', {
            organisasi_id: this.organisasi_id,
            obj: {
              url: `${this.detail.cuti_id}/batal-ajuan`,
            },
          })
        )
        .then(() => {
          this.$info('Data berhasil diajukan')
        })
        .then(() => this.load())
        .catch((e) => e)
    },
    onLampiran() {
      const url = this.getDeepObj(this.detail, 'file_lampiran')
      if (url) window.open(url, '_blank')
    },
  },
}
</script>
